var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.displayValue)?_c('span',[_c('span',{class:{ mismatch: _vm.isDifferent}},[_vm._v(" "+_vm._s(_vm.displayValue)+" ")]),(_vm.isDifferent)?_c('font-awesome-icon',{staticClass:"icon-class",attrs:{"icon":"flag"}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }